export const getDuplicateMessage = (res) => {
 switch (res?.response?.data?.message) {
   case "Code already in use":
     return { key: "code", value: res?.response?.data?.duplicateValue };
   case "Name already in use":
     return { key: "name", value: res?.response?.data?.duplicateValue };
   default:
     return null;
 }
};